__turbopack_context__.v({
  "multi_livestream__schedule_link": "TV8Wra_multi_livestream__schedule_link",
  "multi_livestream__station_info": "TV8Wra_multi_livestream__station_info",
  "multi_livestream__station_info__name_link": "TV8Wra_multi_livestream__station_info__name_link",
  "multi_livestream__station_name": "TV8Wra_multi_livestream__station_name",
  "timezone": "TV8Wra_timezone",
});
